<!--
 * @Author: yuhaiqin@wps.cn
 * @Description: 入口迁移公告
-->
<template>
  <ElCarousel direction="vertical" :autoplay="true" :interval="5000" :loop="true" indicatorPosition="none">
    <ElCarouselItem v-for="(item, index) in list" :key="index" :class="['migrate-tips', item.theme]">
      <IconMyIconTrumpet v-if="item.theme === 'warning'"></IconMyIconTrumpet>
      <IconMyIconTrumpetError v-else></IconMyIconTrumpetError>
      <span>{{ item.title }}</span>
      <div class="button" @click="() => item.event()">
        {{ item.btnText }} <IconMyIconRightArrow></IconMyIconRightArrow>
      </div>
    </ElCarouselItem>
  </ElCarousel>
</template>

<script setup lang="ts">
import { goToWorkbench } from '@/utils/go-to-workbench';
import { ref } from 'vue';
const list = ref([
  {
    title: '功能即将迁移至首页【应用】，下次可以在 "应用市场" 中点击【创建应用】，创建和查看自己的应用哦~',
    btnText: '立即前往',
    theme: 'warning',
    event: () => {
      goToWorkbench();
    },
  },
]);
</script>

<style lang="scss" scoped>
.migrate-tips {
  padding: 0 16px;
  font-size: 12px;
  color: var(--lowcode-warning-03);
  line-height: 22px;
  height: 36px;
  min-height: 36px;
  background: var(--lowcode-warning-05);
  border-radius: 6px;
  border: 1px solid rgba(229, 152, 0, 0.3);
  display: flex;
  align-items: center;
  box-sizing: border-box;
  > span {
    margin: 0 20px 0 8px;
  }
  .button {
    height: 24px;
    background: var(--lowcode-warning-01);
    border-radius: 12px;
    color: var(--lowcode-texts-03);
    display: flex;
    align-items: center;
    padding: 0 6px 0 10px;
    font-size: 12px;
    box-sizing: border-box;
    cursor: pointer;
  }
  &.error {
    background: var(--lowcode-error-05);
    color: var(--lowcode-error-03);
    border-color: var(--lowcode-error-04);
    > svg {
      color: var(--lowcode-error-01);
    }
    .button {
      background: var(--lowcode-error-01);
    }
  }
}

.el-carousel {
  overflow: hidden;
  margin: 12px 24px;
  min-height: 36px;
}
::v-deep .el-carousel__container {
  display: flex;
  align-items: center;
  height: 36px;
}
</style>
